import Feature from "src/js/stores/user/Feature";
import { OwnershipLayerType, OwnershipPlotSizeLayerType } from "../layer_types/OwnershipLayerType";
import { Layer, LayerGroup } from "../types";

export const OWNERSHIP_LAYER_ID = "ownership";

export const OWNERSHIP_LAYER: Layer = {
  id: OWNERSHIP_LAYER_ID,
  layerType: OwnershipLayerType,
  title: "Ownership boundaries",
  toggleable: true,
  requiredFeatureAccess: [Feature.ownershipLayer],
  group: LayerGroup.GENERAL,
  icon: "lt-layer-ownership-boundaries",
  description: "Ownership details and extents",
  layerConfig: {
    minZoom: 12,
  },
  zoomConfig: {
    minVisualisationZoom: 12,
  },
};

export const OWNERSHIP_AREA_PERIMETER_SUMMARY_LAYER: Layer = {
  id: `${OWNERSHIP_LAYER_ID}-plot-size-summary`,
  layerType: OwnershipPlotSizeLayerType,
  title: "Plot size",
  requiredFeatureAccess: [Feature.insightsSummary],
  description: "",
  hideMapLayer: true,
  toggleable: true,
};
